
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tax",
      function () {
        return require("private-next-pages/tax/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tax"])
      });
    }
  